import {
	getTablePricesListsOperationType,
	getTablePricesListsProductsAutoComplete,
	getTablePricesListsSelectionType,
	searchClients
} from 'actions'
import NotificationError from 'components/common/notificationsErrors'
import { Form, Formik, FormikProps } from 'formik'
import { getValidationSchema } from 'lib/FieldValidations'
import {
	IClientsList,
	IOptions,
	IPricesListsMassiveUpdateListFormProps,
	IPricesListsMassiveUpdateListFormState,
	IProductsList,
	ISearchClientsParams
} from 'models/PricesListsMassiveUpdate'
import React, { Component, Fragment } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { TransProps, WithTranslation, withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import PricesListsMassiveUpdateListFormFields from './PricesListsMassiveUpdateListFormFields'

interface IReduxProps {
	getTablePricesListsSelectionType: () => void
	getTablePricesListsOperationType: () => void
	getTablePricesListsProductsAutoComplete: (lk_prod_lp: String) => void
	searchClients: (values: ISearchClientsParams) => void
	operationType: IOptions
	selectionType: IOptions
	search: IClientsList
	productsAutocomplete: IProductsList
}
class PricesListsMassiveUpdateListForm extends Component<
	IPricesListsMassiveUpdateListFormProps &
		TransProps &
		WithTranslation &
		IReduxProps,
	IPricesListsMassiveUpdateListFormState
> {
	constructor(
		props: IPricesListsMassiveUpdateListFormProps &
			IReduxProps &
			TransProps &
			WithTranslation
	) {
		super(props)
		this.state = {
			isSearchingClients: false,
			isSearchingProducts: false
		}
	}

	componentDidMount = () => {
		this.props.getTablePricesListsOperationType()
		this.props.getTablePricesListsSelectionType()
	}

	handleSearchClients = (criterio_cliente: String) => {
		const { idOperacion, searchClients } = this.props
		const newValues = {
			criterio_cliente: criterio_cliente,
			idOperacion: idOperacion
		}
		searchClients(newValues)
		this.handleIsSearchingClients(true)
	}

	handleIsSearchingClients = (isSearchingClients: boolean) => {
		this.setState({ isSearchingClients })
	}

	handleSearchProducts = (lk_prod_lp: String) => {
		const { getTablePricesListsProductsAutoComplete } = this.props
		getTablePricesListsProductsAutoComplete(lk_prod_lp)
		this.handleIsSearchingProducts(true)
	}

	handleIsSearchingProducts = (isSearchingProducts: boolean) => {
		this.setState({ isSearchingProducts })
	}

	handleSelectListValueChange = (value: String) => {
		const { selectionType, handleSelectListValue } = this.props
		const listValue = _.find(
			selectionType?.lista,
			(list) => list.codigo === value
		)
		if (listValue) {
			handleSelectListValue(listValue)
		}
	}

	render() {
		const {
			t,
			fields,
			handleClientsPricesLists,
			handleRedirectPriceList,
			selectionType,
			pricesLists,
			search,
			productsAutocomplete
		} = this.props

		const { isSearchingClients, isSearchingProducts } = this.state
		const disableForm = false

		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		return (
			<Formik
				initialValues={{}}
				onSubmit={(values, actions) => {}}
				enableReinitialize={true}
				validationSchema={{ validationSchema }}
			>
				{(props: FormikProps<any>) => (
					<Fragment>
						<Col sm={12}>
							<NotificationError
								errors={props.errors}
								touched={props.touched}
							/>
						</Col>
						<Col sm={12}>
							<Alert variant={'dark'}>
								<b>{t('CRUDS.general_use.list_selection')}</b>
							</Alert>
						</Col>
						<Form className="container-fluid">
							<Row className="row justify-content-md-center">
								<Col sm={9} className={'ml-3'}>
									<Row>
										{!_.isEmpty(fields) &&
											_.map(fields, (field, index) => {
												return (
													<Col sm={6} key={index}>
														<PricesListsMassiveUpdateListFormFields
															field={field}
															formikProps={props}
															crudProps={this.props}
															initialValue={{}}
															handleClientsPricesLists={
																handleClientsPricesLists
															}
															selectionType={selectionType}
															listProducts={productsAutocomplete}
															listClients={search}
															pricesLists={pricesLists}
															handleSearchClients={this.handleSearchClients}
															handleSearchProducts={this.handleSearchProducts}
															isSearchingClients={isSearchingClients}
															isSearchingProducts={isSearchingProducts}
															handleIsSearchingClients={
																this.handleIsSearchingClients
															}
															handleIsSearchingProducts={
																this.handleIsSearchingProducts
															}
															handleSelectListValueChange={
																this.handleSelectListValueChange
															}
														/>
													</Col>
												)
											})}
									</Row>
								</Col>
								<Col sm={2}>
									<Row className="justify-content-center text-center">
										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'button'}
											onClick={() => handleRedirectPriceList()}
										>
											{t('global.price_list')}
										</Button>
									</Row>
								</Col>
							</Row>
						</Form>
					</Fragment>
				)}
			</Formik>
		)
	}
}
const mapStateToProps = ({ tableCalls, clients }: any) => {
	const { operationType, selectionType, productsAutocomplete } = tableCalls
	const { search } = clients
	return {
		operationType,
		selectionType,
		search,
		productsAutocomplete
	}
}

const connectForm = connect(mapStateToProps, {
	getTablePricesListsOperationType,
	getTablePricesListsSelectionType,
	getTablePricesListsProductsAutoComplete,
	searchClients
})(PricesListsMassiveUpdateListForm)

export default withTranslation()(withRouter(connectForm))
